import styles from './AccountUserHeader.module.scss';

import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

import { PATH } from '@app/index';
import { ArrowButtonIcon, SettingsIcon } from '@assets/icons';
import { BalanceInfo } from '@features/index';
import { useTelegramBackButton } from '@utils/hooks/useTelegramBackButton';
import { isMobile } from '@utils/isMobile';
import { UserInfo } from '@shared/UserInfo';
import { RawButton } from '@shared/RawButton';

type Props = {
  avatar?: string;
  username: string;
  displayNumber: number;
  avatarIsLoading: boolean;
};

export const AccountHeader = ({
  avatar,
  username,
  displayNumber,
  avatarIsLoading,
}: Props) => {
  const nav = useNavigate();

  const tg = window?.Telegram?.WebApp ? window.Telegram.WebApp : undefined;

  const isTelegram = Boolean(tg);
  const isExpanded = tg?.isExpanded ?? false;

  const showTelegramBackButton = isTelegram && isExpanded && isMobile();
  const showArrowButton = !showTelegramBackButton;

  const goBack = useCallback(() => {
    nav(PATH.LOTTERY_ALL_AT_ONCE);
  }, [nav]);

  const goSettings = useCallback(() => {
    nav(PATH.SETTINGS);
  }, [nav]);

  // Показываем системную кнопку «назад» только если в Telegram на мобтльном устройсте и в полноэкранном режиме
  useTelegramBackButton(showTelegramBackButton, goBack);

  return (
    <div className={styles.ahWrapper}>
      {/* Показываем свою кнопку назад, если не в Telegram или не в полноэкранном режиме */}
      {showArrowButton && (
        <RawButton onClick={goBack} className={styles.ahBackButton}>
          <ArrowButtonIcon />
        </RawButton>
      )}
      <RawButton onClick={goSettings} className={styles.ahSettingsButton}>
        <SettingsIcon />
      </RawButton>

      <UserInfo
        avatar={avatar}
        username={username}
        displayNumber={displayNumber}
        avatarIsLoading={avatarIsLoading}
      />

      <BalanceInfo />
    </div>
  );
};
